import { MatIconModule } from "@angular/material/icon";
import { Component, EventEmitter, HostListener, Input, Output } from "@angular/core";

import { CerrixIconButtonComponent } from "@app/incident/components/src/lib/core/cerrix-icon-button/cerrix-icon-button.component";
import { CerrixButtonComponent } from "@app/incident/components/src/lib/core/cerrix-button/cerrix-button.component";

@Component({
    selector: "cerrix-confirmation-button",
    templateUrl: "./cerrix-confirmation-button.component.html",
    styleUrls: ["./cerrix-confirmation-button.component.scss"],
    imports: [MatIconModule, CerrixIconButtonComponent, CerrixButtonComponent],
    providers: []
})
export class CerrixConfirmationButtonComponent {
    @Input() public icon: string = "delete";
    @Input() public btnLabel: string;
    @Input() public dataUiid: string = "undefined";

    @Output() onConfirmationClick = new EventEmitter<void>();

    protected showConfirmation: boolean = false;

    @HostListener("document:click")
    public clickOutside() {
        this.showConfirmation = false;
    }

    protected onIconClick(event: Event) {
        event.preventDefault();
        event.stopPropagation();

        this.showConfirmation = true;
    }

    protected onButtonClick(event: Event) {
        event.preventDefault();
        event.stopPropagation();

        this.onConfirmationClick.emit();
        this.showConfirmation = false;
    }
}
